import { Link } from '@synapex/shared2/gateway-rest-api';

import { api } from '@/shared/api';
import { SnakeIdObj } from '@synapex/tools/typescript';

import * as ReplyParser from './reply-parser';

export const siteLinkMany = ({ site_id }: SnakeIdObj<'site'>) =>
  api
    .get<Link.Site.ManyReply>(`site-2/${site_id}/links`)
    .then(ReplyParser.siteLinkManyReply);

export const channelLinkMany = ({ channel_id }: SnakeIdObj<'channel'>) =>
  api
    .get<Link.Channel.ManyReply>(`channel-2/${channel_id}/links`)
    .then(ReplyParser.channelLinkManyReply);

/////////////////////////////

export const updateSiteLinkCreative =
  ({ site_link_id }: SnakeIdObj<'site_link'>) =>
  (body: SnakeIdObj<'active_creative'>) =>
    api
      .put<Link.Site.OneReply>(`/link/site/${site_link_id}/creative`, body)
      .then(ReplyParser.siteLink);

export const updateChannelLinkCreative =
  ({ channel_link_id }: SnakeIdObj<'channel_link'>) =>
  (body: SnakeIdObj<'active_creative'>) =>
    api
      .put<Link.Channel.OneReply>(
        `/link/channel/${channel_link_id}/creative`,
        body,
      )
      .then(ReplyParser.channelLink);

/////////////////////////////

// export const upsertUrl =
//   ({ site_link_id }: SnakeIdObj<'site_link'>) =>
//   (dto: Link.Site.Url.UpsertInputDto) =>
//     api
//       .put<Link.Site.Url.OneReply>(
//         `/link/site/${site_link_id}/url`,
//         pickDto(Link.Site.Url.UpsertInputDto, dto),
//       )
//       .then(ReplyParser.siteLinkUrl);

// export const deleteUrl =
//   ({ site_link_id }: SnakeIdObj<'site_link'>) =>
//   async () => {
//     await api.delete(`/link/site/${site_link_id}/url`);
//   };
